import React,{useId} from 'react';

/** Segmira: two connected segments forming S. Shared by all application shells. */
export default function BrandMark({size=32,className='',style,...props}) {
 const mask='segmira-'+useId().replace(/:/g,'');
 return <svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 80 80" width={size} height={size} className={className} style={{color:'var(--accent)',flexShrink:0,...style}} aria-hidden="true" focusable="false" {...props}>
  <defs><mask id={mask} maskUnits="userSpaceOnUse" x="0" y="0" width="100" height="100"><rect width="100" height="100" fill="white"/><path d="M47 38L53 62" stroke="black" strokeWidth="5"/></mask></defs>
  <path d="M74 24H42C16 24 16 50 42 50H58C84 50 84 76 58 76H26" fill="none" stroke="currentColor" strokeWidth="18" strokeLinecap="round" mask={`url(#${mask})`}/>
 </svg>;
}
